"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const initialFilters = {
    bodyType: [],
    engineType: [],
    gearType: [],
};
function reduceFilters(state = initialFilters, action) {
    if (!action) {
        return state;
    }
    switch (action.type) {
        case 'add':
            if (state[action.filterType].includes(action.value)) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { [action.filterType]: [...state[action.filterType], action.value] });
        case 'remove':
            if (!state[action.filterType].includes(action.value)) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { [action.filterType]: state[action.filterType].filter((value) => value !== action.value) });
        case 'reset':
            return initialFilters;
    }
}
exports.reduceFilters = reduceFilters;
//# sourceMappingURL=reduce-filters.js.map